import axios from "axios";

/**
 * Resolve the API base URL.
 *
 * Default: `REACT_APP_BACKEND_URL` baked at build time (preview / dev).
 *
 * Override: when the app is served from a custom domain (e.g. `leaseflowr.com`)
 * the Emergent ingress routes *both* the frontend and `/api/*` on that same
 * origin. Calling the build-time URL (`*.emergent.host`) from a custom domain
 * would be cross-origin; Cloudflare rewrites response headers to
 * `Access-Control-Allow-Origin: *` + `credentials: true`, which browsers reject
 * per the CORS spec, surfacing as "Network Error" on signup.
 *
 * Using the current origin makes every call same-origin → no CORS at all.
 * We only switch when we are certain the current host is NOT an Emergent
 * preview/prod domain, so dev/preview behaviour stays unchanged.
 */
function resolveBaseUrl() {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (typeof window === "undefined") return envUrl;
  const host = window.location.hostname;
  const isEmergentDomain =
    host.endsWith(".emergent.host") ||
    host.endsWith(".preview.emergentagent.com") ||
    host === "localhost" ||
    host === "127.0.0.1";
  return isEmergentDomain ? envUrl : window.location.origin;
}

const BASE = resolveBaseUrl();
export const API = `${BASE}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Helpful error -> string
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const detail = err?.response?.data?.detail;
    if (detail) err.message = typeof detail === "string" ? detail : JSON.stringify(detail);
    return Promise.reject(err);
  }
);
